// extracted by mini-css-extract-plugin
export var button = "_98-7";
export var buttonRow = "_98-6";
export var fadeIn = "_98-1";
export var gradient = "_98-0";
export var panel = "_98-2";
export var panelIn = "_98-3";
export var subtitle = "_98-5";
export var title = "_98-4";